
import { Link } from 'react-router-dom';
import { featuredDeals } from '../../../mocks/homepage';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`ri-star-${star <= Math.floor(rating) ? 'fill' : star - 0.5 <= rating ? 'half-fill' : 'line'} text-neon text-xs`}
        ></i>
      ))}
    </div>
  );
}

export default function FeaturedDeals() {
  return (
    <section className="py-24 bg-carbon-900 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-neon/3 blur-[150px]"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="flex items-end justify-between mb-14">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-neon/10 border border-neon/20 mb-4">
              <i className="ri-flashlight-fill text-neon text-sm"></i>
              <span className="text-neon text-xs font-bold uppercase tracking-wider">Limited Time</span>
            </div>
            <h2 className="text-4xl font-bold text-white tracking-tight">Today&apos;s Best Deals</h2>
          </div>
          <Link
            to="/products"
            className="text-sm text-white/40 font-medium hover:text-neon transition-colors flex items-center gap-1.5 cursor-pointer whitespace-nowrap"
          >
            All Deals <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {featuredDeals.map((deal) => (
            <Link
              key={deal.id}
              to="/products"
              className="group bg-carbon-900 overflow-hidden hover:bg-carbon-850 transition-all cursor-pointer"
            >
              <div className="relative w-full h-48 bg-carbon-950 overflow-hidden">
                <img
                  src={deal.image}
                  alt={deal.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500 opacity-80"
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 bg-red-500 text-white text-xs font-bold whitespace-nowrap">
                  -{deal.discount}%
                </div>
                <div className="absolute top-3 right-3 px-2.5 py-1 bg-white/10 backdrop-blur-sm text-white text-xs font-medium whitespace-nowrap border border-white/10">
                  {deal.tag}
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-bold text-white mb-2 group-hover:text-neon transition-colors">{deal.name}</h3>
                <div className="flex items-center gap-2 mb-3">
                  <StarRating rating={deal.rating} />
                  <span className="text-xs text-white/30">
                    ({deal.reviews?.toLocaleString() ?? '0'})
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-lg font-bold text-neon">${deal.dealPrice}/mo</span>
                  <span className="text-sm text-white/30 line-through">${deal.originalPrice}/mo</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
